import { Container, Link, Box } from '@mui/material';
import React from 'react';
import MasonryScss from './Masonry.module.scss';
import OurCover from '../../Component/OurCover/OurCover';
import Slider from "react-slick";
import { MasonryData } from '../../Data/masonryData';


function Masonry() {
    var settings = {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <div>
            <OurCover ourHead="Masonry Modern" title="" />
            {/* masonry */}
            <section id={MasonryScss.masonry}>
                <Container maxWidth='lg'>
                    <Slider {...settings}>
                        {
                            MasonryData.map(masonData =>
                                <Box className={MasonryScss.masonryItem} key={masonData.id}>
                                    {
                                        masonData.masonryImg.map(masonImg =>
                                            <Box className={MasonryScss.masonryItemImg} key={masonImg.id}>
                                                <Link href='#'>
                                                    <img src={masonImg.img} alt={masonImg.img}></img>
                                                    <Box className={MasonryScss.masonryItemImgAbsolute}>
                                                        <span>artdeco</span>
                                                        <p>Light majesty</p>
                                                    </Box>
                                                </Link>
                                            </Box>
                                        )}
                                </Box>
                            )
                        }
                    </Slider>
                </Container>
            </section>
        </div>
    )
}

export default Masonry;
